// @flow
import * as React from 'react';

import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Help } from '@gandi/ui';

type Props = {
  children: React.Node,
};

const InvitationCheckboxWrapper = ({ children }: Props): React.MixedElement => {
  const { __ } = useTranslator();

  return (
    <Base padding="small" backgroundColor="surface">
      {children}
      <Help variant="checkbox">
        {mapTags(
          __(
            'Contacts must accept the invitation before they ' +
              'can view and manage the domains [[docLink:(learn more)]]. ',
          ),
          ({ docLink }) => ({
            docLink: (
              <a
                href={__(
                  'https://docs.gandi.net/en/domain_names/common_operations/manage_domain_contacts.html',
                )}
                target="_blank"
                rel="noopener"
              >
                {docLink}
              </a>
            ),
          }),
        )}
        <br />
        {__(
          'Registries may take some time to update the information on their side.',
        )}
      </Help>
    </Base>
  );
};

export default InvitationCheckboxWrapper;
